module.exports = __webpack_public_path__ + "prod/1.42.2/media/human-resource.0dc7bd6d.mp4";